import { FlexContainer } from '@taxdown/piccolo-web';
import styled from 'styled-components';

export const LoaderContainer = styled(FlexContainer)`
  background: ${({ theme: { colors } }) => colors.white};
  border-radius: ${({ theme: { reference } }) => reference.dimension_16};
  width: 100%;
  max-width: 358px;
  max-height: 358px;
  padding: ${({ theme: { reference } }) => reference.dimension_16};
`;

export const ProgressBarContent = styled.div`
  width: 70%;
`;
